__turbopack_context__.v({
  "content": "Xe2mcW_content",
  "inner": "Xe2mcW_inner",
  "root": "Xe2mcW_root",
  "silhouette": "Xe2mcW_silhouette",
});
